__turbopack_context__.v({
  "creditsButton": "UserNariPoints-module__6oNBGq__creditsButton",
  "currentPoints": "UserNariPoints-module__6oNBGq__currentPoints",
  "currentPoints-hidden": "UserNariPoints-module__6oNBGq__currentPoints-hidden",
  "gainPoints": "UserNariPoints-module__6oNBGq__gainPoints",
  "gainPoints-hidden": "UserNariPoints-module__6oNBGq__gainPoints-hidden",
  "pointHolder": "UserNariPoints-module__6oNBGq__pointHolder",
});
